import { css } from "../__compat__/styled-components/main.entry.mjs.mjs";
export const injectHideScrollBar = () => css `
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
//# sourceMappingURL=injectHideScrollBar.mjs.mjs.map